import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { FaTimes, FaInfo } from 'react-icons/fa'

class EventBanner extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openBanner: true,
    }

    this.hide = this.hide.bind(this)
    this.show = this.show.bind(this)
  }

  hide() {
    this.setState({
      openBanner: false,
    })
  }

  show() {
    this.setState({
      openBanner: true,
    })
  }

  render() {
    const today = new Date();
    if (today > this.props.startDate && today < this.props.endDate){
      if (this.state.openBanner) {
        return (
          <div className={'w-100 relative consulting-banner text-center text-white ' + this.props.cssclass} style={{ top: this.props.position }}>
            <div
              className={'absolute center right '}
              style={{
                top: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            >
              <a className={'toggle-div text-white'} href="/#" onClick={this.hide}>
                <FaTimes size={20}></FaTimes>
              </a>
            </div>
            <div className={'event-banner-animation py-3 px-4'}>
              <b>
                {this.props.content}
              </b>
            </div>
          </div>
        )
      } else {
        return (
          <a className={'toggle-div text-white'} href="/#" onClick={this.show}>
            <div className={'margin-left-auto banner p-3 text-center text-white ' + this.props.cssclass} style={{ top: this.props.position, right: 0, left: 'calc(100% - 50px)' }}>
              <FaInfo size={20}></FaInfo>
            </div>
          </a>
        )
      }
    }else{
      return (
        <></>
      )
    }
  }
}

export default withTranslation()(EventBanner)
